// extracted by mini-css-extract-plugin
export default {"skeleton-grid":"_koipiy","skeletonGrid":"_koipiy","skeleton-grid-3":"_1kx04ps","skeletonGrid3":"_1kx04ps","skeleton-grid-4":"_1kx04pt","skeletonGrid4":"_1kx04pt"};